import { store, reviewStore } from '@/store';
export const navigationItemsMixin = {
    data() {
        return {
            parentItems: [],
            reviewDropDownIndex: null,
            mobileMenuOpen: false,
            storeState: store.state,
            reviewState: reviewStore.state,
            hideMenuItems: false,
        };
    },
    computed: {
        navItems() {
            this.parentItems = this.$globalConstants.host.menu_items || [];
            this.storeState.dropdownItems = this.parentItems.filter(
                (item) => item.dropdown_items
            );
            this.reviewDropDownIndex = this.parentItems.findIndex(
                (item) => item['is_review_menu'] === true
            );
            if (this.reviewDropDownIndex !== -1) {
                this.$eventHub.$on('update-review-dropdown', () => {
                    this.updateReviewDropdownItems();
                });
            }
            return this.parentItems;
        },
    },
    methods: {
        toggleNavMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
        toggleMobileDropdown() {
            this.mobileDropdownOpen = !this.mobileDropdownOpen;
        },
        updateReviewDropdownItems() {
            if (this.reviewState.reviewPartners) {
                let reviewItems = [];
                // grab review links from reviewPartners object in store
                this.reviewState.reviewPartners.forEach((partner) => {
                    let review_slug = Object.keys(partner);
                    let item = {
                        name: partner[review_slug],
                        route: `/review/${review_slug}`,
                    };
                    reviewItems.push(item);
                });
                this.parentItems[this.reviewDropDownIndex]['dropdown_items'] =
                    reviewItems;
                this.storeState.dropdownItems = this.parentItems.filter(
                    (item) => item.dropdown_items
                );
            }
        },
        toggleMenuItems() {
            this.hideMenuItems = !this.hideMenuItems;
        },
    },
    beforeDestroy() {
        if (this.reviewDropDownIndex !== -1) {
            this.$eventHub.$off('update-review-dropdown');
        }
    },
};
